module.exports = __webpack_public_path__ + "img/Wp_2043.96741946.png";